import { render, staticRenderFns } from "./AdminTransfers.vue?vue&type=template&id=5f66ec85&scoped=true"
import script from "./AdminTransfers.vue?vue&type=script&lang=js"
export * from "./AdminTransfers.vue?vue&type=script&lang=js"
import style0 from "./AdminTransfers.vue?vue&type=style&index=0&id=5f66ec85&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f66ec85",
  null
  
)

export default component.exports